import { useState, useCallback } from 'react';

function useDefaultModal() {
    const [dataModal, setDataModal] = useState({ show: false, type: '', message: '', onClose: null });

    const showDefaultModal = useCallback((type, message, onClose = null) => {
        setDataModal({ show: true, type, message, onClose });
    }, []);

    const closeDefaultModal = useCallback(() => {
        let callback = null;
        let type = null;
        setDataModal(prevModalData => {
            callback = prevModalData.onClose;
            type = prevModalData.type;
            return { ...prevModalData, show: false, onClose: null };
        });
        if (callback && type === 'success') {
            callback();
        }
    }, []);

    const resetDefaultModal = useCallback(() => {
        setDataModal({ show: false, type: '', message: '', onClose: null });
    }, []);

    return {
        setDefaultModal: {
            show: dataModal.show,
            type: dataModal.type,
            message: dataModal.message,
            onClose: closeDefaultModal
        },
        showDefaultModal,
        resetDefaultModal,
    };
}

export default useDefaultModal;
